<template lang="">
  <div class="container">
    <div class="title"></div>
    <div class="box">
      <div class="left">
        <div
          class="fb-page page"
          data-href="https://www.facebook.com/callmeemperorvn/"
          data-tabs="timeline"
          :data-width="varyFBW"
          :data-height="varyFBH"
          data-small-header="false"
          data-adapt-container-width="true"
          data-hide-cover="false"
          data-show-facepile="true"
        >
          <blockquote
            cite="https://www.facebook.com/callmeemperorvn/"
            class="fb-xfbml-parse-ignore"
          >
            <a
              href="https://www.facebook.com/callmeemperorvn/"
            >Call Me Emperor</a>
          </blockquote>
        </div>
      </div>
       <div class="right">
        <div class="news_title">
          <ul>
            <li
              v-for="(tit, i) in informations_datas"
              :key="i"
              ref='title_tabs'
              :class="{'checked': i == tab_index}"
              @click="showPic(tit.key,i)"
               @mouseover="showPic(tit.key,i)"
            >
              {{tit.value}}
            </li>
          </ul>
        </div>
      <div class="news_box swiper-container news_box_swiper" id="newsSwiper">
          <div class="swiper-wrapper">
            <div
              v-for="(item, index) in picDatas"
              :key="index"
              class="swiper-slide"
            >
              <a :href="item.url">
              <img class="news_pic" :src="item.image_url" alt="">
              </a>
            </div>
          </div>
          <div class="swiper-button-prev news_prev"></div>
          <div class="swiper-button-next news_next"></div>
          <div class="swiper-pagination pagination"></div>
        </div>

    </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
  name: "six",
  data() {
    return {
      varyFBW: 500,
      varyFBH: 400,
      informations_datas: [
        {
          key: "info",
          value: "Thông tin"
        },
        {
          key: "notice",
          value: "Thông báo"
        },
        {
          key: "activity",
          value: "Hoạt động"
        },
        {
          key: "faq",
          value: "FAQ"
        }
      ],
      picDatas: [],
      pic_data: {},
      tab_index: 0
    };
  },
  created() {
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      this.varyFBH = 240;
      // this.varyFBW = 490
    } else {
      // if (document.body.clientWidth < 1200) {
      //   // this.varyFBW = 390
      // }
      this.varyFBH = 420;
    }
    this.getCarousel();
  },
  mounted() {
    this.newsSwiperInit();
  },
  methods: {
    showPic(key, i) {
      this.tab_index = i;
      this.picDatas = this.pic_data[key];
      this.newsSwiper.slideTo(0, 0, false);
    },
    async getCarousel() {
      const res = await this.APIS.getCarousel();
      this.pic_data = res.data;
      this.picDatas = this.pic_data["info"];
    },
    newsSwiperInit() {
      let that = this;
      that.newsSwiper = new Swiper(".news_box_swiper", {
        observer: true,
        observeParents: true,
        touchRatio: 1,
        longSwipesRatio: 0.1,
        followFinger: false,
        nextButton: ".news_next",
        prevButton: ".news_prev",
        touchMoveStopPropagation: false,
        preventClicksPropagation: false,
        preventLinksPropagation: false,
        paginationClickable: true,
        preventClicks: false, //默认true
        pagination: ".pagination"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  position: relative;
  left: 0;
  right: 0;
  width: 100vw;
  height: 757px;
  background: url("../../assets/img/six/bg.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  .title {
    width: 579px;
    height: 64px;
    margin: 40px auto;
    background: url("../../assets/img/six/title.png") no-repeat;
    background-size: 100% 100%;
  }
  .box {
    width: 1200px;
    height: 400px;
    margin: 80px auto;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .left {
      overflow: hidden;
      width: 514px;
      // height: 454px;
      padding: 10px 0;
      background: url("../../assets/img/six/fb_bg.png") no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;

      .page {
        margin-left: 7px;
        margin-top: 7px;
      }
    }
    .right {
      width: 520px;
      height: 454px;
      ul {
        width: 100%;
        height: 40px;
        display: flex;
        flex-direction: row;
        margin: 0;
        padding: 0;
        border-bottom: 1.2px solid #f3b8b8;

        li {
          height: 34px;
          line-height: 34px;
          text-align: center;
          width: 120px;
          color: red;
          list-style: none;
          margin-right: 30px;
          cursor: pointer;
          &.checked {
            background: #f8c6c6;
            color: #c35959;
          }
        }
      }
      .news_box {
        margin: 5px auto;
        width: 100%;
        height: 400px;
        // position: relative;
        // .swiper-slide {
        //   height: 350px;
        // }
        .swiper-slide {
          height: 350px;
        }
        .news_pic {
          width: 100%;
          height: 350px;
        }
        .news_prev,
        .news_next {
          width: 32px;
          height: 56px;
          margin-top: -40px;
          z-index: 12;
        }
        .news_prev {
          background: url("../../assets/img/six/left_arrow.png") no-repeat;
          background-size: 100% 100%;
        }
        .news_next {
          background: url("../../assets/img/six/right_arrow.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
  .swiper-button-next.swiper-button-disabled,
  .swiper-button-prev.swiper-button-disabled {
    pointer-events: auto;
  }
  .news_box /deep/ span.swiper-pagination-bullet {
    display: inline-block;
    width: 15px;
    height: 15px;
    background: url("../../assets/img/six/unchecked.png") no-repeat;
    background-size: 100% 100%;
  }
  .news_box
    /deep/
    span.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 20px;
    background: url("../../assets/img/six/checked.png") no-repeat;
    background-size: 100% 100%;
  }
}

@media screen and (max-width: 640px) {
  .container {
    // widows: 100vw;
    // height: 757px;
    // background: url("../../assets/img/six/bg.png") no-repeat;
    // background-size: 100% 100%;
    // overflow: hidden;
    // position: relative;
    // left: 0;
    // right: 0;
    width: 100vw;
    height: 11.52rem;
    background: url("../../assets/img/six/phone_bg.png") no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    .title {
      width: 5.79rem;
      height: 0.64rem;
      margin: 0.3rem auto 0;
      background: url("../../assets/img/six/title.png") no-repeat;
      background-size: 100% 100%;
    }
    .box {
      width: 7.2rem;
      height: 10rem;
      margin: 0.4rem auto 0;
      display: block;
      // display: flex;
      // flex-direction: column;
      // align-items: center;
      // justify-content: space-around;
      overflow: hidden;
      .left {
        overflow: hidden;
        width: 5.6rem;
        // height: 4.96rem;
        // min-height: 4.44rem;
        background: url("../../assets/img/six/fb_bg.png") no-repeat;
        background-size: 100% 100%;
        // padding-top: 0.08rem;
        padding: 0.08rem 0.08rem 0.08rem 0.08rem;
        margin: 0 auto;
        box-sizing: border-box;
        .page {
          margin-left: 0;
          margin-top: 0;
          // padding: -0.2rem;
        }
      }
      .right {
        width: 5.4rem;
        // height: 5.46rem;
        height: 5.06rem;
        padding: 0.1rem;
        box-sizing: border-box;
        margin: 0.1rem auto 0;
        ul {
          width: 100%;
          height: 0.6rem;
          display: flex;
          flex-direction: row;
          margin: 0;
          padding: 0;
          border-bottom: 1.2px solid #f3b8b8;
          font-size: 0.2rem;
          li {
            height: 0.5rem;
            line-height: 0.5rem;
            text-align: center;
            width: 2rem;
            color: red;
            list-style: none;
            margin-right: 0rem;
            cursor: pointer;
            &.checked {
              background: #f8c6c6;
              color: #c35959;
            }
          }
        }
        .news_box {
          margin: 5px auto;
          width: 100%;
          height: 4.4rem;
          // position: relative;
          .swiper-slide {
            height: 3.6rem;
          }

          .news_pic {
            width: 100%;
            height: 3.5rem;
          }
          .news_prev,
          .news_next {
            width: 0.32rem;
            height: 0.56rem;
            margin-top: -0.4rem;
            z-index: 12;
          }
        }
      }
    }
       .news_box /deep/ span.swiper-pagination-bullet {
        display: inline-block;
        width: 0.2rem;
        height: 0.2rem;
        background: url("../../assets/img/six/unchecked.png") no-repeat;
        background-size: 100% 100%;
      }
      .news_box
        /deep/
        span.swiper-pagination-bullet.swiper-pagination-bullet-active {
        width: 0.25rem;
        height: 0.25rem;
        background: url("../../assets/img/six/checked.png") no-repeat;
        background-size: 100% 100%;
      }
    .fb-page.fb_iframe_widget.fb_iframe_widget_fluid {
      width: 100%;
      // margin-left: 10px;
    }
  }
}
@media screen and (max-width: 320px) {
  .container{
    .title{
       margin: 0.18rem auto 0;
    }
    .box{
      margin: 0.12rem auto 0;
    }
  }
}
</style>
<style lang="less">

</style>

